

'use strict';

import $ from 'jquery';


export function setupAccountDelete () {
    const toggleAccountDeleteBtn = document.querySelector('.toggle-account-delete');
    const accountDeletePassword = document.querySelector('#account-delete-password');
    const accountDeleteForm = document.querySelector('.account-delete-form');

    if ( toggleAccountDeleteBtn ) {
        toggleAccountDeleteBtn.addEventListener('click', evt => {
            evt.preventDefault();

            $('.account-delete-form').slideToggle();
        });

        if ( accountDeleteForm ) {
            accountDeleteForm.addEventListener('submit', evt => {
                evt.preventDefault();

                const formData = new FormData();
                formData.append('password', accountDeletePassword.value);

                window.fetch('/ajax/Customer/delete',
                {
                    method: 'POST',
                    body: formData,
                })
                    .then(response => response.json())
                    .then(response => {
                        if ( response.header.code === 200 ) {
                            window.location.replace(`/?message=${encodeURI(response.data)}`);
                        } else {
                            accountDeletePassword.dataset.error = response.data;

                            const prevErrorMsg = accountDeletePassword.nextElementSibling;
                            if ( prevErrorMsg.classList.contains('error') ) {
                                prevErrorMsg.remove();
                            }

                            const errorMsg = document.createElement('small');
                            errorMsg.classList.add('error');
                            errorMsg.innerHTML = response.data;

                            accountDeletePassword.after(errorMsg);
                        }
                    });
            });
        }
    }
};
